// Simple global store for image resize dimensions
class ImageResizeStore {
  private dimensions: { [imageSrc: string]: { width: number; height: number } } = {};

  setDimensions(imageSrc: string, width: number, height: number) {
    console.log('🏪 STORE: Setting dimensions for', imageSrc, { width, height });
    this.dimensions[imageSrc] = { width, height };
  }

  getDimensions(imageSrc: string) {
    return this.dimensions[imageSrc];
  }

  getAllDimensions() {
    return { ...this.dimensions };
  }

  clear() {
    this.dimensions = {};
  }

  // Debug function to see what URLs we have stored
  listStoredUrls() {
    return Object.keys(this.dimensions);
  }

  // Debug function to log all stored data
  debugStore() {
    console.log('🏪 STORE DEBUG: All stored dimensions:', this.dimensions);
    console.log('🏪 STORE DEBUG: Stored URLs:', this.listStoredUrls());
    return this.dimensions;
  }
}

export const imageResizeStore = new ImageResizeStore();
